export enum DateRange {
  PAST_7_DAYS = "past_7_days",
  PAST_30_DAYS = "past_30_days",
  PAST_60_DAYS = "past_60_days",
  PAST_90_DAYS = "past_90_days",
}
